(() => {
  if (customElements.get('joffz-collection-directory')) return;
  customElements.define('joffz-collection-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      this.labels = JSON.parse(this.querySelector('[data-directory-labels]').textContent);
      this.cards = [...this.querySelectorAll('[data-directory-card]')];
      this.input = this.querySelector('[data-directory-search]');
      this.page = 1;
      this.pageSize = Math.max(12, Math.min(48, Number(this.dataset.pageSize) || 24));
      this.querySelector('[data-directory-tools]').hidden = false;
      this.addEventListener('input', event => {
        if (event.target !== this.input) return;
        this.page = 1;
        this.render();
      }, { signal: this.controller.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-directory-reset]')) {
          this.input.value = ''; this.page = 1; this.render(); this.input.focus();
        }
        const next = event.target.closest('[data-directory-next]');
        const prev = event.target.closest('[data-directory-prev]');
        if ((next || prev) && !event.target.closest('button').disabled) {
          this.page += next ? 1 : -1;
          this.render();
          const card = this.cards.find(item => !item.hidden)?.querySelector('a');
          card?.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          card?.focus({ preventScroll: true });
        }
      }, { signal: this.controller.signal });
      this.render();
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
    normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim(); }
    render() {
      const query = this.normalize(this.input.value);
      const terms = query.split(/\s+/).filter(Boolean);
      const matching = this.cards.filter(card => terms.every(term => this.normalize(card.dataset.title).includes(term)));
      const pages = Math.max(1, Math.ceil(matching.length / this.pageSize));
      this.page = Math.max(1, Math.min(this.page, pages));
      const visible = new Set(matching.slice((this.page - 1) * this.pageSize, this.page * this.pageSize));
      this.cards.forEach(card => { card.hidden = !visible.has(card); });
      this.querySelector('[data-directory-status]').textContent = matching.length === 1 ? this.labels.one : this.labels.many.replace('999', String(matching.length));
      this.querySelector('[data-directory-reset]').hidden = !query;
      this.querySelector('[data-directory-pagination]').hidden = pages <= 1;
      this.querySelector('[data-directory-prev]').disabled = this.page === 1;
      this.querySelector('[data-directory-next]').disabled = this.page === pages;
      this.querySelector('[data-directory-page]').textContent = this.labels.page + ' ' + this.page + ' / ' + pages;
      const empty = this.querySelector('[data-directory-empty]');
      empty.hidden = matching.length > 0;
      empty.textContent = this.labels.empty.replace('[query]', this.input.value.trim());
    }
  });
})();

